import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const LeadsNotificationPreferencesModalContainerLoadable =
  clientOnlyLazy({
    loader: () =>
      import(
        /* webpackChunkName: "LeadsNotificationPreferencesModalContainer" */
        './LeadsNotificationPreferencesModalContainer.dynamic'
      ),
    loading: LoadingModal,
  });
